//////////////////////////
// GT COOKIES FUNCTIONS //
//////////////////////////

var GTCookies = function () {
    this.cookieName = "cookiePolicy";

    this.setCookie = function (name, value, expires, path, domain) {
        var today = new Date();
        today.setTime(today.getTime());

        /*
        if the expires variable is set, make the correct expires time, the current script below will set
        it for x number of days, to make it for hours, delete * 24, for minutes, delete * 60 * 24
        */
        if (expires) {
            expires = expires * 1000 * 60 * 60 * 24;
        }
        var expires_date = new Date(today.getTime() + expires);

        document.cookie = name + "=" + encodeURI(value) +
            (expires ? ";expires=" + expires_date.toGMTString() : "") +
            (path ? ";path=" + path : "") +
            (domain ? ";domain=" + domain : "") +
            ";secure";
        var checkCookies = "/Cookies/CheckCookies";
        $.ajax({
            cache: false,
            url: checkCookies,
            type: "post",
            dataType: "json",
            success: function (data) {
                console.log("check cookies successfully");
            },
            error: function (xhr) {
                console.error(xhr);
            }
        });
	};

	this.setCookieWithoutServerCheck = function (name, value, expires, path, domain) {
		var today = new Date();
		today.setTime(today.getTime());

		/*
		if the expires variable is set, make the correct expires time, the current script below will set
		it for x number of days, to make it for hours, delete * 24, for minutes, delete * 60 * 24
		*/
		if (expires) {
			expires = expires * 1000 * 60 * 60 * 24;
		}
		var expires_date = new Date(today.getTime() + expires);

		document.cookie = name + "=" + encodeURI(value) +
			(expires ? ";expires=" + expires_date.toGMTString() : "") +
			(path ? ";path=" + path : "") +
			(domain ? ";domain=" + domain : "") +
			";secure";
	};

    /** @id getCookie */
    this.getCookie = function (name) {
        if (document.cookie.length > 0) {
            var c_start = document.cookie.indexOf(name + "=");
            if (c_start !== -1) {
                c_start = c_start + name.length + 1;
                var c_end = document.cookie.indexOf(";", c_start);
                if (c_end === -1) {
                    c_end = document.cookie.length;
                }
                return decodeURI(document.cookie.substring(c_start, c_end));
            }
        }
        return "";
    };
    
    this.deleteCookie = function (name) {
        var me = this;
        if (me.getCookie(name)) {
            document.cookie = name + "=; expiresThu, 01 Jan 1970 00:00:01 GMT;";
        }
    };

    this.cookieNotify = function () {
        var me = this;

        if (this.getCookie(this.cookieName)) {
            document.querySelector("#skipcookie")?.remove();
            return;
        }

        var cprompt = $('div.cookie-block');
        var cookieCTA = cprompt.find(".cookie-cta");

        $(cprompt).show();

        // set the cookie and close the box
        cookieCTA.on("click keydown  touchend", function (e) {
            if (!e.keyCode || e.keyCode === 13) {
                $(cprompt).slideUp('slow');
                me.setCookie(me.cookieName, $(e.currentTarget).val(), 365, '/');
                e.preventDefault();
                document.querySelector("#skipcookie")?.remove();
                return false;
            }
        });
    };
};
let linkTertiaryList = [];

GT.LinkTertiary = function () {
    linkTertiaryList.push(setTimeout(() => {
        let hiddenLinkAnimation = document.querySelector("body");
        if(hiddenLinkAnimation) {
            hiddenLinkAnimation.classList.remove("hidden-link__animation");
        }
    }, 350))
}

GT.hideHyperLinkAnimation = function() {
    linkTertiaryList.forEach(timer => {
        clearTimeout(timer);
    })
    
    let _body = document.querySelector("body");
    if(!_body.classList.contains('hidden-link__animation')) _body.classList.add('hidden-link__animation');
    GT.LinkTertiary();
}

GT.domContentLoadedFncList.push(function(){
    GT.LinkTertiary();
});

GT.clampData = {
    "aboutblock": [
        {selector: '.gt-small-title > a'},
        {selector: '.gt-body-text', lines: 5}
    ],
    "ibcblock": [
        {selector: '.ibc-suggested__descriptions', lines: 4}
    ],
    "newsblock": [
        {selector: '.gt-small-title > a'},
        {selector: '.news-title-text'},
        {selector: '.gt-body-text', lines: 5}
        // {selector: '.news-text', lines: 5, isHidden: false}
    ],
    "relatedcontentwithimage": [
        {selector: '.event-item__title--gridview'},
        {selector: '.rcwib_item-content-category', lines: 1},
        {selector: '.rcwib_item-content-title', lines: 2}
    ],
    "relatedcontentnoimage": [
        {selector: '.event-item__title--gridview'},
        {selector: '.rcwib_item-content-category', lines: 1},
        {selector: '.rcwib_item-content-title', lines: 2},
        {selector: '.article-tile .title', lines: 2},
        {selector: '.article-tile .text', lines: 5},
        {selector: '.four-items-per-view .article-tile .text', lines: 3}
    ],
    "event-block": [
        {selector: '.event-item__title--gridview'},
        {selector: '.event-item__title--listview', lines: 2},
        {selector: '.grid-view .js-single-event-name'},
        {selector: '.list-view .js-single-event-name', lines: 2},
        {selector: '.single-event-block .js-single-event-name', lines: 2}
    ],
    "semminar-block": [
        {selector: '.list-view .js-single-semminar-name', lines: 2},
        {selector: '.single-event-block .js-single-semminar-name', lines: 2}
    ],
    "insight-hub-block": [
        { selector: '.article-content__clamp .content .title', lines: 3 },
        { selector: '.article-content__clamp .content-bottom .text', lines: 3 }
    ],
    "global-article-clamp": [
        { selector: '.global-article__list--items .article-content__clamp .content .category', lines: 1 },
        { selector: '.global-article__list--items .article-content__clamp .content .title', lines: 3 },
        { selector: '.global-article__list--items .article-content__clamp .content .text', lines: 3 }
    ],
    "upcoming-events__results": [
        {selector: '.event-item__title--gridview'},
        {selector: '.event-item__title--listview', lines: 2}
    ],
    "tombstone": [
        {selector: '.tombstone-block-container .item-transaction'},
        {selector: '.tombstone-block-container .item-business', lines: 4}
    ],
    "tombstone-transaction": [
        { selector: '.transaction-action__container .transaction-action', lines: 2 }
    ],
    "eventdetailpagev2": [
        {selector: '.title', lines: 1}
    ],
    "mega-menu-v2": [
        {selector: '.mega-content__item .mega-link', lines: 2, renderAtPageLoad: true},
        {selector: '.mega-content__item .mega-content__item--descriptions', lines: 3, renderAtPageLoad: true}
    ],
    "t11-result-v2": [
        {selector: '.result-card__desc'},        
        {selector: '.result-card__people-desc'}
    ]
}

GT.getLineHeight = function ($elem) {
    if($elem) {
        let computedStyle = window.getComputedStyle($elem);
        let fontSize = parseFloat(computedStyle.fontSize.replace("px",""));
        let lineHeight = computedStyle.lineHeight.replace("px","");
        if(lineHeight == "normal")
            lineHeight = 1.2 * fontSize;
        return parseFloat(lineHeight);
    }
};

GT.getNumberLineContent = function ($elem) {
    try {
        var divheight = $elem.offsetHeight; 
        var lineheight = GT.getLineHeight($elem);
        return Math.round(divheight/parseInt(lineheight));
    } catch (e) {
        return 0;
    }
};

GT.clampArticleBlock = function ($elem, isForceReRender){
    let articleText = $elem.querySelector('.text'),
        articleTitle = $elem.querySelector('.title'),
        authorElm = $elem.querySelector('.page-promote__info'),
        isNoImage = $elem.classList.contains("no-image"),
        isNoDescription = $elem.classList.contains("no-description"),
        isTrending = $elem.classList.contains("trending"),
        isReverse = $elem.classList.contains("reverse"),
        isMediumDesktopView = GT.isMediumDesktopView(),
        clampText = 3,
        elClamp = 3;

    if(!articleTitle) return;
    
    if(articleText && !articleText.dataset.clamptext) {
        articleText.dataset.clamptext = articleText.textContent;
    }

    if(!articleTitle.dataset.clamptext) {
        articleTitle.dataset.clamptext = articleTitle.textContent;
    }

    let numberLine = GT.getNumberLineContent(articleTitle),
        authorLine = 0;
    
    if(authorElm) {
        authorLine = GT.getNumberLineContent(authorElm);
    }

    if (numberLine > 3) isNoImage && !isNoDescription && isMediumDesktopView ? elClamp = 4 : elClamp = 3;
    else elClamp = numberLine;

    
    let customLineClamp = getCustomClampLines(articleTitle);
    if(customLineClamp != -2)
        elClamp = customLineClamp;
        
    if(authorLine > 1 && elClamp > 2) {
        elClamp = elClamp - authorLine + 2 - (isTrending || isReverse ? 1 : 0);
    }

    var objTitle = {
        settings: { clamp: elClamp, isHidden: true}
    }

    if(elClamp > -1 && articleTitle) {
        if(isForceReRender) {
            articleTitle.removeAttribute("data-lazyevent-triggered");
            articleTitle.textContent = articleTitle.dataset.clamptext;
        }
        GT.Clamp(articleTitle, objTitle, isForceReRender);
        $elem.setAttribute('clamp', true);
    }
    
    // Apply only for featured article block in T1, T9 and T39
    clampText = 6 - elClamp;
    if(isNoImage) {
        if(elClamp == 4) clampText = 3;
        if(elClamp == 3) clampText = 4;

        if(isMediumDesktopView) {
            if(elClamp == 2) clampText = 6;
            if(elClamp == 1) clampText = 8;
        } else {
            if(elClamp == 2) clampText = 5;
            if(elClamp == 1) clampText = 7;
        }
    }


    if(articleTitle?.closest(".mega-featured__contents")) {
        if (numberLine > 3) elClamp = 3;
        clampText = 5 - elClamp;
    } else if(authorLine > 1)
        clampText = clampText - authorLine + 1;

    if(articleText) {
        customLineClamp = getCustomClampLines(articleText);
        if(customLineClamp != -2)
            clampText = customLineClamp;

        var objText = {
            settings: { clamp: clampText, isHidden: true}
        }

        if(clampText > -1) {
            if(isForceReRender) {
                articleText.removeAttribute("data-lazyevent-triggered");
                articleText.textContent = articleText.dataset.clamptext;
            }
            GT.Clamp(articleText, objText, isForceReRender);
            $elem.setAttribute('clamp', true);
        }
    }
}

function getCustomClampLines(clampElm){
    let _lines = -2;
    if(clampElm && clampElm.dataset.clamplines) {
        let _tmpLines = JSON.parse(clampElm.dataset.clamplines);

        if(GT.wWidth < GT.breakPoints.tablet_lg)
            _lines = _tmpLines.mobile;
        else
            _lines = _tmpLines.desktop;
    }
    return _lines;
}

GT.Clamp = function (elem, obj, isForceReRender) {
    if(!elem.dataset) return;

    let spaces = true;
    const lang = document.documentElement.lang;
    if(["zh", "ja"].indexOf(lang) >= 0) spaces = false;

    var lines = obj.settings.clamp || 3; // a default
    var isHidden = obj.settings.isHidden || false;
    var doClamp = function execute(current) {
        var lineHeight = GT.getLineHeight(current);
        var containerHeight = lineHeight * lines;

        if (current.offsetHeight > containerHeight || isHidden) {
            var height = containerHeight + parseInt(lineHeight / 2.5);
            if (height)
                shave(current, height, {spaces: spaces});
        }
    };

    let clampKey = elem.dataset.clampkey,
        oldClampKey = null;

    if(!clampKey || isForceReRender) {
        if(isForceReRender) {
            oldClampKey = clampKey;
                
            // delete GT.listFunctionsTriggerInScrollEvent[oldClampKey];
            // delete GT.windowResizeFncList[oldClampKey];
        }
        clampKey = 'lazy_clampKey_' + (Math.random() * (1000000 - 0) + 0);
        elem.dataset.clampkey = clampKey;
    }

    if(obj.settings.renderAtPageLoad)
        doClamp(elem);
    else
        LazyEvent([elem], doClamp, null, isForceReRender, clampKey, oldClampKey);
};

GT.initClampText = function(elmSelector, clampName){
    let elms = document.querySelectorAll(elmSelector);
    Array.prototype.slice.call(elms).forEach(function(elm){
        elm.dataset.clampname = clampName;
        elm.classList.add("clamp-text");
    })
}

GT.clampText = function(clampName, isForceReRender){
    function doClamp(elm){
        //let ClampText function auto collect selectors. Just call GT.clampText() or GT.clampText(null, true) to force rerender
        elm.classList.add("clamp-text");
        let clampData = GT.clampData[elm.dataset.clampname];
        if(clampData){
            const clampDataLength = clampData.length;
            for(let i = 0; i < clampDataLength; i++) {
                const clampItem = clampData[i],
                    clampSelectors = elm.querySelectorAll(clampItem.selector),
                    clampSelectorsLength = clampSelectors.length;
                
                for(let clampElmIndex = 0; clampElmIndex < clampSelectorsLength; clampElmIndex++) {
                    const clampElm = clampSelectors[clampElmIndex];
                    if(!clampElm.dataset.clamptext)
                        clampElm.dataset.clamptext = clampElm.innerText || clampElm.text || clampElm.textContent;
                    if(isForceReRender || clampItem.isHidden) {
                        delete clampElm.dataset.lazyeventTriggered;
                        clampItem.isHidden = true;
                    }

                    let customLineClamp = getCustomClampLines(clampElm);
                    if(customLineClamp != -2)
                        clampItem.lines = customLineClamp;

                    if(clampItem.lines > -1 || clampItem.lines == null) {
                        GT.Clamp(clampElm, {settings: {isHidden: clampItem.isHidden, renderAtPageLoad: clampItem.renderAtPageLoad, clamp: clampItem.lines || 3}}, isForceReRender);
                    }
                }
            }
        }
    }

    let clampElms = [];

    if(clampName) {
        clampElms = document.querySelectorAll("[data-clampname=" + clampName + "]");
    } else {
        clampElms = document.querySelectorAll("[data-clampname]");
    }

    const clampElmsLength = clampElms.length;
    for(let i = 0; i < clampElmsLength; i++) {
        const item = clampElms[i];
        try{
            if(isForceReRender)
                GT.clampRevertToOriginalText(item.dataset.clampname);
            setTimeout(e => {
                doClamp(item);
            })
        }catch(e){
            console.log(e);
        }
    }
}

GT.clampRevertToOriginalText = function(clampElmName){
    Array.prototype.slice.call(document.querySelectorAll("[data-clampname=" + clampElmName + "]")).forEach(function(item){
        try{
            let clampData = GT.clampData[item.dataset.clampname];
            if(clampData){
                Array.prototype.slice.call(clampData).forEach(function(clampItem){
                    let clampElms = item.querySelectorAll(clampItem.selector);
                    Array.prototype.slice.call(clampElms).forEach(function(clampElm){
                        if(clampElm.dataset.clamptext) {
                            clampElm.innerText = clampElm.dataset.clamptext;
                        }
                    })
                })
            }
        }catch(e){
            console.log(e);
        }
    })
}


GT.clampArticle = function(isForceReRender){
    //only apply for mega menu if it opens
    let $article = document.querySelectorAll(document.querySelector(".mega__level--2.open") ? '.mega__level--2.open .article-tile' : '.gt-wrapper .article-tile');

    $article.forEach(function(item){
        item.removeAttribute("clamp");
        GT.clampArticleBlock(item, isForceReRender);
    })
}

GT.retriggerClampList = {};

GT.domContentLoadedFncList.push(function(){
    GT.clampArticle();
    GT.clampText();
});

GT.windowResizeFncList.clampTextOnResize = function() {
    GT.clampArticle(true);
    GT.clampText(null, true);
    Object.keys(GT.retriggerClampList).forEach(clampItemKey => {
        GT.retriggerClampList[clampItemKey]();
    })
};
var initTranslationDetect = function() {
	var allowTranslator = allowTranslateDetector();
	if(!allowTranslator) return;
    var originalLang = $('html').attr('lang');
	var observer = new MutationObserver(checkLang);
	function checkLang(){
		var currentLang = $('html').attr('lang');
        if (currentLang !== originalLang){
        	$('body').addClass('lang-changed');
			$(window).trigger('user-translate');
			originalLang = currentLang;
        }
	}
	var htmlDom = document.getElementsByTagName('html')[0];
	observer.observe(htmlDom,  { attributes: true, childList: false, subtree: false });

	function allowTranslateDetector(){
		var hasMutation = typeof MutationObserver !== undefined;
		var isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
		var notMobile = window.screen.width > 768;
		return hasMutation && isChrome && notMobile;
	}
}

initTranslationDetect();
GT.InputLabel = function ($elem) {

    var input = $($elem).children('input');
    var label = $($elem).children('label');

    input.on('input', function (e) {
        if (input.val() != 0) {
            label.css('opacity', '0');
        } else {
            label.css('opacity', '1');
        }
    });

};

GT.HeadSearch = function ($element) {
    var me = this,
        $toggle = $element.find('.icon-link'),
        $content = $element.find('.header__search-form'),
        $search = $content.find('.searchBox'),
        $close = $element.find('.h-search__close'),

        $parent = $element.parent(),
        $globalreach = $parent.find('.header__global-reach-toggle'),
        $lang = $parent.find('.header__lang'),
        $login = $parent.find('.header__login');
    $header = $parent.parent();

    function is_iOS() {
        var iDevices = [
            'iPad Simulator',
            'iPhone Simulator',
            'iPod Simulator',
            'iPad',
            'iPhone',
            'iPod'
        ];

        while (iDevices.length) {
            if (navigator.platform === iDevices.pop()) {
                return true;
            }
        }

        return false;
    }


    function fixNav() {
        if (is_iOS()) {
            $('body').css('overflow-y', 'auto');
            $('body').css('position', 'absolute');
            $('body').css('top', 0);
            $('body').css('bottom', 0);
            $('body').css('-webkit-overflow-scrolling', 'touch');

            $(document).on('resize', function () {
                $('body').scrollTop(topShift);
            })
        }
    }
    function unfixNav() {
        if (is_iOS()) {
            $('html, body').removeClass('absolute');
        }
    }
    function closeSearch() {                
        $element.removeClass('open');
        $content.removeClass('open');
        $toggle.css({ 'display': '' });
        $lang.css({ 'display': '' });
        $login.css({ 'display': '' });
        $globalreach.css({ 'display': '' });
        $content.css({ 'position': 'absolute' });
        $('.mobile-logo').removeClass('hide');
        document.getElementById('searchField').blur();
        setTimeout(function(){
            $toggle.focus();
        }, 50)
    }

    me.init = function () {

        // fixNav();

        var $toggle = $element.find('.icon-link'),
            $content = $element.find('.header__search-form'),
            $close = $element.find('.h-search__close');
        $parent = $element.parent();
        $globalreach = $parent.find('.header__global-reach-toggle');
        $lang = $parent.find('.header__lang');
        $login = $parent.find('.header__login');

        topShift = $(window).scrollTop();

        $('body').on('touchmove', function () {
            topShift = $(window).scrollTop();
            document.activeElement.blur();
        })

        $toggle.on('click keydown', function (e) {            
            if (!e.keyCode || e.keyCode === '13') {
                $('.insight-menu__toggle').removeClass('open');
                $element.addClass('open');
                $content.addClass('open');
                $search.focus();
                $(this).css({ 'display': 'none' });
                $globalreach.css({ 'display': 'none' });
                $lang.css({ 'display': 'none' });
                $login.css({ 'display': 'none' });
                $content.css({ 'position': 'relative' });
                $('.mobile-logo').addClass('hide');
                document.getElementById('searchField').focus();
            }
        });

        $close.on('click keydown', function (e) {
            if (!e.keyCode || e.keyCode === 13) {
                closeSearch();
            }
        });

        // $content.find('.searchBox').blur(function () {
        //     closeSearch();
        // });


    }
    me.init();
};
GT.Reveal = function ($elements, obj) {
    // var isMobile = GT.isMobile();
    // // $elements.forEach(elm => {
    // document.querySelectorAll(".reveal-item").forEach(function(childElm){
    //     if(isMobile)
    //         childElm.classList.add("use-banner-zoom");
    //     else
    //         childElm.classList.add("use-block-element-fade-in");
    // })
    // })
    // return;
    // var current = this;
    // if (typeof obj.settings === 'undefined') {
    //     obj.settings = {};
    // }

    // // SETTINGS
    // current.settings = $.extend({}, {
    //     animationType: 'fromBottom',
    //     dataDelay: 'reveal-delay',
    //     dataTransition: 'transition',
    //     customAnimation: null,
    //     rvlItemClass: null,
    // }, obj.settings);

    // // CREATE SCROLL REVEAL ANIMATION OBJECT
    // current.revealObj = ScrollReveal(current.settings.customAnimation || current.GetAnimation(current.settings.animationType));

    // // GET REVEAL ELEMENT AND REVEAL CONTAINER IF IT IS SET
    // current.rvlItemClass = current.settings.rvlItemClass;

    // // SEQUENCE ANIMATION IF CONTAINER IS SET
    // if (!GT.isMobile() && !sessionStorage['animationDone'] || $("." + current.rvlItemClass).attr("data-replay") == "true") {
    //     $element.each(function () {
    //         current.revealAnimation();
    //     });
    //     sessionStorage['animationDone'] = 'true';
    // } else {
    //     $('.' + current.rvlItemClass).addClass('still');
    //     $('.' + current.rvlItemClass).removeClass(current.rvlItemClass);
    // }
};

// Animations to obj prototype
GT.Reveal.prototype.GetAnimation = function (animationType) {
    var current = this;
    var defaultAnimation = {
        duration: 0,
        easing: 'cubic-bezier(0.4, 0.0, 0.2, 1)',
        distance: '0rem',
        opacity: 1,
        scale: 1,
        viewFactor: 0.2,
        beforeReveal: function () {
            current.revealAnimation();
        }
    }
    switch (animationType) {
        case 'fromBottom':
            return $.extend({}, defaultAnimation, {
                origin: 'bottom'
            })
        default:
            return defaultAnimation
    }
};

GT.Reveal.prototype.revealAnimation = function () {
    var current = this;
    var targetElements = $('.' + current.rvlItemClass);
    for (var i = 0; i < targetElements.length; i++) {
        var elem = targetElements[i];
        var className = elem.getAttribute('data-transition');
        var delay = elem.getAttribute('data-reveal-delay');
        new revealElement(elem, className, delay);
    }
}

function revealElement(elem, className, delay) {
    $(elem).css({ 'animation-delay': delay + 'ms' })
    elem.classList.add(className);
}


GT.Animation = function () {
    if (GT.isMobileView()) return;

    GT.checkElmVisible(".scroll-animation__container", function (intersectObj) {
        let target = intersectObj.target;
        target.querySelectorAll(".animation-item").forEach(function (item) {
            if (item.dataset.animationDelay)
                item.style.animationDelay = item.dataset.animationDelay;
            if (item.dataset.y)
                item.style.setProperty('--element-fade-in-y', item.dataset.y);
            (typeof item.dataset.transition != "undefined") && item.classList.add(item.dataset.transition);
        })
    });
}

GT.domContentLoadedFncList.push(GT.Animation);
GT.windowResizeFncList.GTAnimation = GT.Animation;
function GTSkipLink(){
    Array.prototype.slice.call(document.querySelectorAll(".shortcuts a")).forEach(function(shortcut){
        shortcut.addEventListener("click", function(e){
            e.preventDefault();
            let ahref = "#" + e.target.href.split("#")[1],
                target = document.querySelector(ahref);

            if(ahref == "#skip-nav"){
                let insightToggleBtn = document.querySelector(".insight-menu__toggle");
                const firstFocusableElement = target.querySelector("ul.level-1 li")?.querySelector("a, button");
                if(insightToggleBtn) {
                    insightToggleBtn.click();
                    setTimeout(function(){
                        firstFocusableElement?.focus();
                    }, 500)
                } else
                    firstFocusableElement?.focus();
            } else if(ahref == "#skip-cookie") {
                let lstElm = GT.getListFocusableElms(document.querySelector(".cookie-block"));
                if(lstElm.length) {
                    lstElm[0].focus();
                }
            } else {
                GT.getFirstFocusableVisible()?.focus();
            }
        })
    })
}

GT.domContentLoadedFncList.push(function(){
    GTSkipLink();
});

GT.fakeHyperLinkClickEvtList = [];
GT.fakeHyperLinkKeypressEvtList = [];
GT.FakeHyperlink = function () {
    Array.prototype.slice.call(document.querySelectorAll('[data-anchor]')).forEach(function (el, index) {
        GT.fakeHyperLinkClickEvtList.forEach(function (func, funIdx) {
            el.removeEventListener("click", func);
        })
        GT.fakeHyperLinkKeypressEvtList.forEach(function (func, funIdx) {
            el.removeEventListener("keypress", func);
        })
    })
    GT.fakeHyperLinkClickEvtList = [];
    GT.fakeHyperLinkKeypressEvtList = [];


    function redirectLink(linkElm){
        window.open(linkElm.dataset.anchor, linkElm.getAttribute("target") ? linkElm.getAttribute("target") : '_self');
    }

    Array.prototype.slice.call(document.querySelectorAll('[data-anchor]')).forEach(function (el) {
        el.setAttribute("tabindex", 0);
        el.setAttribute("role", "link");

        function handleClickEvt(e) {
            redirectLink(e.currentTarget);
        }
        function handleKeypressEvt(e) {
            if (e.keyCode == 13)
                redirectLink(e.currentTarget);
        }

        GT.fakeHyperLinkClickEvtList.push(handleClickEvt);
        GT.fakeHyperLinkKeypressEvtList.push(handleKeypressEvt);
        el.addEventListener("click", handleClickEvt);
        el.addEventListener("keypress", handleKeypressEvt);
    })

    Array.prototype.slice.call(document.querySelectorAll('[data-anchor] a')).forEach(function (el) {
        el.setAttribute("role", "link");
        el.addEventListener("click", function(e){
            e.stopPropagation();
        });
    })
};
///////////////////////////
// GT OVERLAYS FUNCTIONS //
///////////////////////////

function GTOverlays() {

    var me = this;
    var lastFocusElement;

    this.calculateOverlayH = function ($container, screenH, overlayH) {
        var offSetH = 0;
        $container.removeClass("full-height");
        if (overlayH > screenH) {
            $container.addClass("full-height");
        } else {
            offSetH = (screenH - overlayH) / 2;
        }

        return offSetH;
    };

    this.getWindowWidth = function ($window) {
        var winWidth;
        if ($('html').hasClass('lt-ie9')) {
            winWidth = document.body.clientWidth;
        } else {
            winWidth = $window.width();
        }

        return winWidth;
    };

    this.getWindowHeight = function ($window) {
        var winHeight;
        if ($('html').hasClass('lt-ie9')) {
            winHeight = document.body.clientHeight / 4;
        } else {
            winHeight = Math.max($window.height(), window.innerHeight);
        }

        return winHeight;
    };

    //reset Epi form
    this.resetEpiForm = function(){
        setTimeout(function(){
            if ($('.newsletter-container').length >= 1) 
                $('.newsletter-container .content > div').removeAttr('style');
        }, 600);
    }

    function autoFocusAtFirstElm(elm){
        var tabbable = elm.find('select, input, textarea, button, a, [role="button"]').filter(':visible');
        var firstTabbable = tabbable.first();
        var lastTabbable = tabbable.last();
        /*set focus on first input*/
        setTimeout(() => {
            firstTabbable.focus();
        }, 500)

        /*redirect last tab to first input*/
        lastTabbable.on('keydown', function (e) {
            if ((e.which === 9 && !e.shiftKey)) {
                e.preventDefault();
                firstTabbable.focus();
            }
        });

        /*redirect first shift+tab to last input*/
        firstTabbable.on('keydown', function (e) {
            if ((e.which === 9 && e.shiftKey)) {
                e.preventDefault();
                lastTabbable.focus();
            }
        });
    }

    // try this
    this.runOverlay = function (htmlOrRef, container, containerWidth, containerHeight, checkH, isNewsletter, doNotAddBindings, callbackOnClose) {
        var screenW, screenH;

        var $window = $(window);
        var screenW = me.getWindowWidth($window);
        var screenH = me.getWindowHeight($window);
        var removeOnClose = false;

        var $body = $('body');
        $body.addClass('overlay-no-scroll');
        $('html').addClass('overflowHidden');

        if (!$(".overlay").length) {
            $body.append('<div class="overlay"></div>');
        } else {
            $(".overlay").show();
        }
        if (typeof htmlOrRef === 'string' || htmlOrRef instanceof String) {
            $(".overlay").after(htmlOrRef);
            removeOnClose = true;
        } else if (htmlOrRef instanceof Element) {

        } else {
            return false;
        }

        // ok, so we have to check if our overlay isn't heigher than window
        var $container = $(container);
        if (checkH) {
            $container.width('100%');
        }
        var overlayH = $container.outerHeight(true);
        var offSetH = me.calculateOverlayH($container, screenH, overlayH);

        var scrollTop = $(window).scrollTop();
        var offSetL = (screenW - containerWidth) / 2;

        // Blur all inputs / textareas with placeholders to init on browsers LTE IE9
        if ($("html").hasClass('lte-ie9')) {
            $container.find("[placeholder]").blur();
        }

        // if offset is <0 make offset 10 else the overlay will appear off the screen on mobile.
        if (offSetL < 0) {
            offSetL = 0;
        }

        if (isNewsletter) {
            $container.css({ 'position': 'fixed' });
        } else {
            offSetH = offSetH + scrollTop;
        }

        $('.overlay').bind('touchmove', function (event) {
            event.preventDefault();
        })

        var closeOverlay = function(){
            //issue: cannot remove container in T32, so have to query selector again
            let _container = $(container);
            if ($('.overlay').is(':visible')) {
                me.hideOverlay();
                if (lastFocusElement) {
                    lastFocusElement.focus();
                }
                if (removeOnClose) {
                    _container.remove();
                } else {
                    _container.fadeOut();
                    me.resetEpiForm();
                }
                if (GT.isFunction(callbackOnClose)) {
                    callbackOnClose();
                }
            }
        }

        if (!doNotAddBindings) {
            $(document).on('resize', function () {
                setTimeout(function () {
                    $container.css({ 'overflow': 'auto' });
                    $container.css('-webkit-overflow-scrolling', 'touch');
                    $container.css('max-height', 'calc(100vh - 40px)');
                }, 1000)
            });

            $(document).on('keydown', function (e) {
                if (e.keyCode === 27) { // ESC
                    closeOverlay();
                }
            });

            $('.js-close-overlay').on('click', function () {
                //lastFocusElement = this;
                closeOverlay();
                return false;
            });
        }

        $('.overlay').on('click', function (e) {
            // lastFocusElement = this;
            closeOverlay();
            e.stopImmediatePropagation();
            return false;
        });

        $container.fadeIn();
        if (!$container.is(".contact-form-popup") && !$container.is(".popup-contact-me-form")  && !$container.is(".focusable-form")) {
            me.overlayTabNavHandlerOnOpen();
        } else {
            $container.css('display','flex');
            // if($container.is(".focusable-form")) {
            // }
            
            autoFocusAtFirstElm($container);
        }
        GT.hideHyperLinkAnimation();
        return true;
    };
    // / try this

    // hide overlay function
    this.hideOverlay = function () {

        $('.overlay').off('click');
        var $body = $('body');
        $body.removeClass('overlay-no-scroll');
        if(!document.firstElementChild.classList.contains("opening-mobile-menu"))
            $('html').removeClass('overflowHidden');

        var $window = $(window);
        var screenW = me.getWindowWidth($window);


        var top = Math.abs(parseInt($('body').css('top'), 10));

        GT.setInertWhileOpeningDialog(false);
        $('.overlay').fadeOut('slow');
        me.overlayTabNavHandlerOnClose();
    };

    // youtube overlay
    this.youTubeOverlay = function (url) {
        var winWidth = $(window).innerWidth();
        var winHeight = $(window).innerHeight();
        var playerWidth = winWidth * 0.8;//560,

        //if(playerWidth > 1000) playerWidth = 1000;

        var playerHeight = playerWidth / 1.6;//315,

        if (playerHeight > winHeight) {
            playerHeight = winHeight * 0.8;
            playerWidth = playerHeight * 1.6;
        }

        if (winWidth <= 480) {
            playerWidth = 320;
            playerHeight = 200;
        }

        var regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
        var videoID = url.match(regExp);

        if (videoID && videoID[2].length == 11) {
            videoID = videoID[2];
        } else {
            videoID = false;
        }

        if (videoID) {
            url = 'https://www.youtube.com/embed/' + videoID;
        }
        // var htmlMarkup = '<div class="youtube-container"><a href="#" class="js-close-overlay"><img src="../images/sprites/close-video-wh.png" alt="close video" /></a><iframe width="'+playerWidth+'" height="'+playerHeight+'" src="http:'+url+'?autoplay=1" frameborder="0" allowfullscreen></iframe></div>';
        var htmlMarkup = '<div class="youtube-container"><iframe id="' + videoID + '" width="' + playerWidth + '" height="' + playerHeight + '" src="' + url + '?rel=0&autoplay=1&enablejsapi=1&vq=large" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></div>';
        var container = '.youtube-container';

        me.runOverlay(htmlMarkup, container, playerWidth, playerHeight, false, false);
        me.hideRelatedVideoInYoutube(container);
    };

    // vimeo overlay
    this.vimeoVideoOverlay = function (me, id, playerWidth, playerHeight) {
        var htmlMarkup = '<div class="youtube-container"><iframe src="https://player.vimeo.com/video/' + id + '?autoplay=1" width="' + playerWidth + '" height="' + playerHeight + '" allow="autoplay" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe></div>';

        var container = '.youtube-container';

        me.runOverlay(htmlMarkup, container, playerWidth, playerHeight, false, false);
    };

    // vimeo thumbnail
    this.vimeoVideoThumbNail = function (me, currentElem, videoID) {
        currentElem.addClass("lazyload");
        currentElem.attr('data-bgset', 'https://vumbnail.com/' + videoID + '.jpg');
    };

    // youtube overlay
    this.youTubeVideoOverlay = function (me, id, playerWidth, playerHeight) {
        var htmlMarkup = '<div class="youtube-container"><iframe id="'+ id +'" src="https://www.youtube.com/embed/' + id + '?rel=0&autoplay=1&enablejsapi=1&vq=large"  width="' + playerWidth + '" height="' + playerHeight + '" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe></div>';
        var container = '.youtube-container';
        me.runOverlay(htmlMarkup, container, playerWidth, playerHeight, false, false);
        me.hideRelatedVideoInYoutube(container);
    };

    var player;
    this.loadPlayer = function (playerFrame) {
        if (typeof (YT) == 'undefined' || typeof (YT.Player) == 'undefined') {
            var tag = document.createElement('script');
            tag.src = "https://www.youtube.com/iframe_api";
            var firstScriptTag = document.getElementsByTagName('script')[0];
            firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

            window.onYouTubePlayerAPIReady = function () {
                me.onYouTubePlayer(playerFrame);
            };
        } else {
            me.onYouTubePlayer(playerFrame);
        }
    }

    this.onYouTubePlayer = function (playerFrame) {
        player = new YT.Player(playerFrame, {
            videoId: playerFrame,
            events: {
                'onReady': me.onPlayerReady,
                'onStateChange': me.onPlayerStateChange
            }
        });
    }
    
    this.onPlayerReady = function (event) {
        event.target.playVideo();
    }

    this.onPlayerStateChange = function (event) {
        if (event.data == YT.PlayerState.ENDED) {
            if (typeof player !== 'undefined' && typeof  player.seekTo != "function"){
                event.target.a.contentWindow.postMessage('{"event":"command","func":"' + 'stopVideo' + '","args":""}', '*');
            }else{
                player.seekTo(0, false);
                player.stopVideo();
            }
        }
    }
    this.hideRelatedVideoInYoutube = function (container) {
        var playerFrame = $(container).find("iframe");
        me.loadPlayer(playerFrame.attr("id"));
    }

    // generic overlay
    this.newsletterOverlay = function () {

        var containerWidth = 640,
            containerHeight = 457;
        var winWidth = $(window).innerWidth();
        if (containerWidth < winWidth) {
            containerWidth = winWidth;
        }

        // html content
        var heading = 'Subscribe to our newsletters',
            newsletter1 = 'Email newsletter option 1',
            newsletter1copy = 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas eu ante lorem. Phasellus at lacinia nunc. Nullam iaculis quis nunc facilisis luctus.',
            newsletter2 = 'Email newsletter option 2',
            newsletter2copy = 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas eu ante lorem. Phasellus at lacinia nunc. Nullam iaculis quis nunc facilisis luctus.',
            submitURL = '#';

        var htmlMarkup = '<div class="newsletter-container"><div class="header"><h2>' + heading + '</h2><a href="#" class="js-close-overlay"><i class="icon-close"></i><span class="ir">Close</span></a></div><div class="content"><div class="checkbox-inline"><input id="newsletter1" type="checkbox"><label for="newsletter1"><span></span>' + newsletter1 + '</label><p>' + newsletter1copy + '</p><input id="newsletter2" type="checkbox"><label for="newsletter2"><span></span>' + newsletter2 + '</label><p>' + newsletter2copy + '</p></div><div class="footer"><label for="subscribeEmail" class="reader">First name</label><input class="input-name errors" type="text" id="subscribeEmail" value="Your email address"><a href="' + submitURL + '" class="subscribe-btn">Subscribe here</a></div></div></div>';

        var container = '.newsletter-container';

        me.runOverlay(htmlMarkup, container, containerWidth, containerHeight, true, true);
    };

    this.openVideoInNewTab = function (currentElem) {

        currentElem.blur();
        var EXIT = true,
            CONTINUE = false;
        var win = false;

        if (currentElem.hasClass('video__open-in-new-tab')) {
            win = window.open(currentElem.attr("href"), '_blank');
            if (win) {
                //Browser has allowed it to be opened
                win.focus();
            }
            return EXIT;
        }
        return CONTINUE;
    }

    this.launchOverlay = function ($elem, obj) {
        function handleClick(e){
            if (!e.keyCode || e.keyCode === '13') {
                e.preventDefault();
                if (!me.openVideoInNewTab($(e.srcElement))) {
                    // on click - button name changes to "loading..." at the end
                    // open the modal
                    var youtubeLink = e.srcElement.href;
                    if (youtubeLink && youtubeLink.length > 0) {
                        me.youTubeOverlay(youtubeLink);
                    }
                }
            }
        }
        $elem.each(function(idx, item){
            item.onclick = handleClick;
            item.onkeydown = handleClick;
        })
    };

    this.launchVideoOverlay = function (elem, obj) {
        var
            vimeoRegExp = /https?:\/\/(?:www\.|player\.)?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/([^\/]*)\/videos\/|album\/(\d+)\/video\/|video\/|[\w]+\/review\/|)(\d+)(?:\/(\w+))?(?:$|\/|\?)/,
            youtubeRegExp = /^.*(?:(?:youtu\.be\/|v\/|vi\/|u\/\w\/|embed\/)|(?:(?:watch)?\?v(?:i)?=|\&v(?:i)?=))([^#\&\?]*).*/,
            playerWidth = 560,
            playerHeight = 315,
            winWidth = $(window).innerWidth();

        if (winWidth <= 480) {
            playerWidth = 320;
            playerHeight = 200;
        }

        function handleLaunchOfVideoOverlay(videoID, playerWidth, playerHeight, videoFunction) {
            // on click - button name changes to "loading..." at the end
            // open the modal
            videoFunction(me, videoID, playerWidth, playerHeight);
        };

        elem.each(function () {
            var $current = $(this),
                videoLink = $current.attr("href"),
                videoID = 0;
            var vimeoMatch, youtubeMatch;
            if (videoLink && videoLink.length > 0) {
                vimeoMatch = videoLink.match(vimeoRegExp);
                youtubeMatch = videoLink.match(youtubeRegExp);
            }

            if (vimeoMatch) {
                videoID = vimeoMatch[3];
                if(!$current.parent(".press-video").length)
                    me.vimeoVideoThumbNail(me, $current, videoID);
            } else if (youtubeMatch) {
                videoID = youtubeMatch[1];
                if(!$current.parent(".press-video").length) {
                    $current.addClass("lazyload");
                    $current.attr('data-bgset', 'https://img.youtube.com/vi/' + videoID + '/maxresdefault.jpg');
                }
                // $current.attr('style', 'background-image: url(" https://img.youtube.com/vi/' + videoID + '/maxresdefault.jpg");');
            }
        })

        
        function handleClick(e){
            if (!e.keyCode || e.keyCode === '13') {
                var currentElm = e.srcElement,
                    videoLink = currentElm.href,
                    videoID = 0;
                var vimeoMatch, youtubeMatch;
                if (videoLink && videoLink.length > 0) {
                    vimeoMatch = videoLink.match(vimeoRegExp);
                    youtubeMatch = videoLink.match(youtubeRegExp);
                }
                e.preventDefault();
                if (!me.openVideoInNewTab($(currentElm))) {
                    if (vimeoMatch) {
                        videoID = vimeoMatch[3];
                        handleLaunchOfVideoOverlay(videoID, playerWidth, playerHeight, me.vimeoVideoOverlay);
                    } else if (youtubeMatch) {
                        videoID = youtubeMatch[1];
                        handleLaunchOfVideoOverlay(videoID, playerWidth, playerHeight, me.youTubeVideoOverlay);
                    }
                }
                
            }
        }

        elem.each(function (idx, item) {
            item.onclick = handleClick;
            item.onkeydown = handleClick;
        });
    };

    this.launchNewsletter = function ($elem) {

        //opening the overlay and the basket
        $($elem).on('click keydown', function (e) {
            if (!e.keyCode || e.keyCode === '13') {
                // on click - button name changes to "loading..." at the end
                // open the modal
                me.newsletterOverlay();
                return false;
            }
        });
    };

    this.overlayContactProcess = function(elem, container, postFormURL){
        var $optionErrors = $(container).find(".checkbox-inline .error");
        var $emailErrors = $(container).find(".footer .error");
        // FocusTrap
        var findInsiders = function (elem) {
            //reset
            var content = elem.find('.content');
            content.find('input, textarea, select').val('');
            content.find('input[type=checkbox], input[type=radio]').prop('checked', false); 
            $optionErrors.empty().addClass('hide');
            $emailErrors.empty().addClass('hide');
            
            autoFocusAtFirstElm(elem);

            /* allow escape key to close insiders div */
            elem.on('keyup', function (e) {
                if (e.keyCode === 27) {
                    lastFocusElement.focus();
                    me.resetEpiForm();
                    elem.hide();
                };
            });
        };

        findInsiders($(container));
        var recaptchaContainer = $(container).find(".g-recaptcha");
        var recaptcha = null;
        if (recaptchaContainer.length) {
            recaptcha = new GT.Captcha(recaptchaContainer, {
                settings: {
                    error_origin: "selector",
                    error_value: "",
                    error_selector: "data-captcha-error",
                    error_where: "after"
                }
            });
        }
        $(container).find("a.subscribe-btn").click(function (e) {
            e.preventDefault();

            var $btn = $(this);
            if ($btn.attr('disabled') === 'disabled') {
                return false;
            }

            var $selectedCbxs = $(container).find(".checkbox-inline input:checked");
            var email = $(container).find("input#subscribeEmail").val();
            var keys = [];
            var hpc = $(container).find('.hpc').val();
            var recaptchaVal = "";
            if (recaptcha) {
                recaptchaVal = $(container).find('.g-recaptcha-response').val();
            }

            if ((recaptcha && !recaptcha.captchaChecked)) {
                recaptcha.showRecaptchaErrorMsg();
                return false;
            }
            $btn.attr('disabled', 'disabled');

            $.each($selectedCbxs, function (i, val) {
                keys.push($(val).attr("id"));
            });
            var subscribeFormModel = {
                Email: email,
                Keys: keys,
                HoneyPotCaptcha: hpc,
                CurrentLanguage: window.gtConfig.currentLanguageId,
                ReCaptchaToken: recaptchaVal,
                ContactPageId: $("#ContactPageId").val()
            };
            var jsonData = JSON.stringify(subscribeFormModel);
            var postFormAjaxOptions = {
                url: postFormURL,
                type: "POST",
                data: jsonData,
                contentType: "application/json; charset=utf-8",
                dataType: "json",
                success: function (data, results, info) {
                    $btn.removeAttr('disabled');
                    if (data.Success) {
                        $('.newsletter-container .content').children('div:not(.thanks)').hide();
                        $('.thanks').find('a.close').addClass('link-btn link-btn-page');
                        $('.newsletter-container .thanks').show();
                        findInsiders($(container));
                        $('.newsletter-container .thanks').find('.close').on('click', function (e) {
                            e.preventDefault();
                            $(container).find(".js-close-overlay").click();
                            me.resetEpiForm();
                            lastFocusElement.focus();
                        });
                    } else {
                        if (!data.IsEmailValid) {
                            $.each(data.EmailErrors, function (i, val) {
                                $emailErrors.empty();
                                $emailErrors.append($("<p />").text(val));
                                $emailErrors.removeClass("hide");
                            });
                        } else {
                            $emailErrors.addClass("hide");
                        }
                        
                        if (!data.AreKeysValid) {
                            $.each(data.KeysErrors, function (i, val) {
                                $optionErrors.empty();
                                $optionErrors.append($("<p />").text(val));
                                $optionErrors.removeClass("hide");
                            });
                        } else {
                            $optionErrors.addClass("hide");
                        }
                    }
                },
                // if error (302) - honeypot GTE-462
                error: function (data) {
                    //$('.newsletter-container .content').empty().append(data.responseText);
                    $optionErrors.empty().append(data.responseText).removeClass('hide');
                    $btn.removeAttr('disabled');
                }
            };
            $.ajax(postFormAjaxOptions);
        });
    }

    this.loadOverlayContact = function (elem) {

        $(elem).click(function (e) {
            e.preventDefault();
            lastFocusElement = this;
            var postFormURL = $(this).data('postajax');
            var url = $(this).data('href');
            var containerWidth = 640, containerHeight = 457;
            var container = '.newsletter-container';
            var winWidth = $(window).innerWidth();

            //FocusTrap
            if (containerWidth > winWidth) {
                containerWidth = winWidth;
            }

            if (url != "#") {
                container = '.newsletter-container[subscribe-overlay]';
                var options = {
                    url: url,
                    success: function (data, results, info) {
                        me.runOverlay(data, container, containerWidth, containerHeight, true, true);
                        me.overlayContactProcess(elem, container, postFormURL);
                    }
                };
                $.ajax(options);
            }else{
                me.runOverlay(document.getElementsByClassName('newsletter-container')[0], container, containerWidth, containerHeight, true, true);
                me.overlayContactProcess(elem, container, postFormURL);
            }
        });
    },
        this.loadOverlaySeminar = function (elem) {
            elem.click(function (e) {
                e.preventDefault();
                var postFormURL = $(this).data('postajax');
                var options = {
                    url: $(this).attr('href'),
                    success: function (data, results, info) {
                        var containerWidth = 640, containerHeight = 457;
                        var container = 'form.subscribe-semminars-container';
                        var winWidth = $(window).innerWidth();
                        if (containerWidth > winWidth) {
                            containerWidth = winWidth;
                        }
                        me.runOverlay(data, container, containerWidth, containerHeight, true, true);
                        var $container = $(container);
                        var recaptchaContainer = $container.find(".g-recaptcha");
                        var recaptcha = null;
                        if (recaptchaContainer.length) {
                            recaptcha = new GT.Captcha(recaptchaContainer, {
                                settings: {
                                    error_origin: "selector",
                                    error_value: "",
                                    error_selector: "data-captcha-error",
                                    error_where: "after"
                                }
                            });
                        }

                        $(document).on("submit", container, function (e) {
                            e.preventDefault();

                            var current = this;
                            var $nameError = $(current).find("#nameErrorMessage");
                            var $emailError = $(current).find("#emailErrorMessage");
                            var $optionsError = $(current).find("#optionsErrorMessage");
                            var $optinError = $(current).find("#optinErrorMessage");

                            $nameError.addClass("hide");
                            $nameError.prev().removeClass("errors");
                            $emailError.addClass("hide");
                            $emailError.prev().removeClass("errors");
                            $optinError.addClass("hide");
                            $optionsError.addClass("hide");

                            var $btn = $(this).find(".subscribe-btn");
                            if ($btn.attr('disabled') === 'disabled') {
                                return false;
                            }
                            var $selectedCbxs = $(current).find(".js-seminar-keys .checkbox-inline input:checked");
                            var $selectedOptin = $(current).find(".js-seminar-optin .checkbox-inline input:checked");
                            var name = $(current).find("input#subscribeName").val();
                            var email = $(current).find("input#subscribeEmail").val();
                            var hpc = $(current).find('.hpc').val();
                            var valid = {};
                            valid.Email = /^[-a-z0-9~!$%^&*_=+}{\'?]+(\.[-a-z0-9~!$%^&*_=+}{\'?]+)*@([a-z0-9_][-a-z0-9_]*(\.[-a-z0-9_]+)*\.([a-z]([a-z])+)|([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}))(:[0-9]{1,5})?$/i.test(email);
                            valid.Name = name.length > 0 && /^\D+$/i.test(name);
                            valid.Optin = $selectedOptin.length;
                            valid.Keys = $selectedCbxs.length;

                            if (!valid.Name) {
                                $nameError.removeClass("hide");
                                $nameError.prev().addClass("errors");
                            }
                            if (!valid.Email) {
                                $emailError.removeClass("hide");
                                $emailError.prev().addClass("errors");
                            }
                            if (!valid.Optin) {
                                $optinError.removeClass("hide");
                            }
                            if (!valid.Keys) {
                                $optionsError.removeClass("hide");
                            }
                            if (valid.Email && valid.Keys && valid.Name && valid.Optin && hpc.length === 0) {
                                var postFormAjaxOptions = {
                                    url: postFormURL,
                                    type: "POST",
                                    dataType: "json",
                                    data: $(current).serialize(),
                                    contentType: "application/json; charset=utf-8",
                                    dataType: "json",
                                    success: function (data) {
                                        $btn.removeAttr('disabled');
                                        $nameError.addClass("hide");
                                        $emailError.addClass("hide");
                                        $optinError.removeClass("hide");
                                        $optionsError.addClass("hide");

                                        $('.subscribe-semminars-container .content').children().hide();
                                        $('.thanks').show().parent().show();
                                        $('.field-group, .footer').hide();
                                        $('.thanks').find('a.close').addClass('link-btn link-btn-page');
                                        $('.subscribe-semminars-container .thanks').show().find('.close').on('click', function (e) {
                                            e.preventDefault();
                                            $(current).find(".js-close-overlay").click();
                                        });
                                    },
                                    // if error (302) - honeypot GTE-462
                                    error: function (data) {
                                        // $('.subscribe-semminars-container .content').empty().append(data.responseText);
                                        $btn.removeAttr('disabled');
                                    }
                                };
                                try {
                                    if ((recaptcha && recaptcha.captchaChecked) || !recaptcha) {
                                        $.ajax(postFormAjaxOptions);
                                    }
                                } catch (ex) {
                                    console.warn(ex);
                                }
                            }
                        });

                    }
                };
                $.ajax(options);
            });
        };

    this.calculateAndSetOverlayPos = function ($overlay, isNewsletter) {

        // get window width & height
        var $window = $(window);
        var winWidth = me.getWindowWidth($window);
        var winHeight = me.getWindowHeight($window);

        // get overlay width & height
        var overlayW = $overlay.outerWidth(true);
        $overlay.css({ 'height': '' });
        var overlayH = $overlay.outerHeight(true);
        // if overlay is heigher or wider than window - adjust it's size
        // center overlay in window (vertically & horizontally)
        if (overlayH > winHeight) {
            $overlay.css({ 'height': winHeight + 'px', 'overflow': 'auto' });
            // no need to center
        } else {
            // center vertically
            if (isNewsletter) {
                var topOffset = (winHeight - overlayH) / 2;
            } else {
                var topOffset = ((winHeight - overlayH) / 2) + $window.scrollTop();
            }
            $overlay.css({ 'top': topOffset + 'px' });
        }

        if (overlayW > winWidth) {
            $overlay.width(winWidth);
            // no need to center
        } else {
            // center horizontally
            var leftOffset = (winWidth - overlayW) / 2;
            $overlay.css({ 'left': leftOffset + 'px' });
        }

    };

    this.resizeOverlay = function ($elem) {

        // resize overlay if it's open
        $(window).resize(function () {
            var $overlay = $('.overlay');
            if ($overlay.length && $overlay.css('display') !== 'none') {
                //me.calculateAndSetOverlayPos($('.newsletter-container'), true);
            }
        });
    };

    this.overlayTabNavHandlerOnOpen = function () {

        $("*[tabindex != '-1']:visible").each(function () {
            var $this = $(this);
            if (!$this.closest('.newsletter-container').length && !$this.closest('.expert-modal').length) {
                $this.attr('tabindex', '-1').addClass('js-tabbable-blocked');
            }
        });
    };

    this.overlayTabNavHandlerOnClose = function () {

        $('.js-tabbable-blocked').each(function () {
            $(this).removeAttr('tabindex').removeClass('js-tabbable-blocked');
        });
    };

    let htmlElm = document.firstElementChild;   

    //Performance issue
    // this.initHeaderOverlay = function () {
    //     let headerOverlayHtml = '<div class="header-overlay"></div>',
    //         body = htmlElm.querySelector('body');
        
    //     // body.innerHTML += headerOverlayHtml;
    //     body.insertAdjacentHTML("beforeend", headerOverlayHtml);
    // }
    // this.initHeaderOverlay()
    
    
    this.toggleHeaderOverlay = function() {        
        htmlElm.classList.toggle('opening-header-overlay')
    }
    
    this.showHeaderOverlay = function() {        
        htmlElm.classList.add('opening-header-overlay')
    }
    
    this.hideHeaderOverlay = function() {        
        htmlElm.classList.remove('opening-header-overlay')
    }

};


GT.Overlays = new GTOverlays();
GT.domContentLoadedFncList.push(function(){
    if(typeof isV1GT == "undefined") {
        GT.Overlays.launchVideoOverlay($('.video__with-overlay'));
        GT.Overlays.launchOverlay($('.youtube-video'));
        GT.Overlays.loadOverlayContact($('#launchContactFormSubscribe:not([data-epiforms-overlay])'));
        GT.Overlays.loadOverlaySeminar($('#launchSemminarsFormSubscribe'));
    }
});

GT.EmailObfuscate = function (elem) {
	$(document).on('mouseover touchstart focus',
		'[data-obfuscate-specific="true"]',
		function (e) {
			var $m = $(this);
			var href = $m.attr('href');
			if (!href) {
				$m.attr('target', '_blank');
				var user = $m.data('user');
				var domain = $m.data('domain');
				var subject = $m.data('subject');
				var bccUser = $m.data('bccuser');
				var bccDomain = $m.data('bccdomain');
				if (user != '' && domain != '') {
					var email = user + '@' + domain;
					var emailOnly = email;
					if (subject != '' && subject != undefined && subject != null) {
						email = email + '?subject=' + subject;
						if (bccUser != '' && bccUser != undefined && bccUser != null) {
							var bcc = bccUser + '@' + bccDomain;
							email = email + '&bcc=' + bcc;
						}
					} else {
						if (bccUser != '' && bccUser != undefined && bccUser != null) {
							var bcc = bccUser + '@' + bccDomain;
							email = email + '?bcc=' + bcc;
						}
					}
					$m.closest("a").attr('href', 'mailto:' + email);
					var isMobile = GT.isMobile();
					if (!isMobile && $($m, ".email-obfuscate").length) {
						var $emailObfucate = $m.find(".email-obfuscate");
						var $buttonText = $emailObfucate.parents('.button-vi-text');
						$emailObfucate.remove();
						if($buttonText.length <= 0) {
							$m.append('<span>' + emailOnly + '</span>');
						} else {
							$buttonText.text(emailOnly);
						}
					}
					if (GT.isIE()) {
						$m[0].blur();
					}
				}
			}
		});

	if (typeof(isEnableMailtoDialog) == "undefined" || !isEnableMailtoDialog) {
		$(document).on('mouseover touchstart focus',
			'[data-obfuscate="true"]',
			function (e) {
				var $m = $(this);
				var href = $m.attr('href');
				if (!href) {
					$m.attr('target', '_blank');
					var user = $m.data('user');
					var domain = $m.data('domain');
					var subject = $m.data('subject');
					var bccUser = $m.data('bccuser');
					var bccDomain = $m.data('bccdomain');
					if (user != '' && domain != '') {
						var email = user + '@' + domain;
						if (subject != '' && subject != undefined && subject != null) {
							email = email + '?subject=' + subject;
							if (bccUser != '' && bccUser != undefined && bccUser != null) {
								var bcc = bccUser + '@' + bccDomain;
								email = email + '&bcc=' + bcc;
							}
						} else {
							if (bccUser != '' && bccUser != undefined && bccUser != null) {
								var bcc = bccUser + '@' + bccDomain;
								email = email + '?bcc=' + bcc;
							}
						}
						$m.closest("a").attr('href', 'mailto:' + email);
						if (GT.isIE()) {
							$m[0].blur();
						}
					}
				}
			});
	} else {
		$(document).on('click',
			'[data-obfuscate="true"]',
			function (e) {
				e.preventDefault();
				var $m = $(this);
				if($m.attr("data-obfuscate-specific"))
					return;
				$m.attr('href', "#");
				if ($m && mailtoDialogTemplate) {
					var user = $m.data('user');
					var domain = $m.data('domain');
					var subject = $m.data('subject');
					var bccUser = $m.data('bccuser');
					var bccDomain = $m.data('bccdomain');
					if (user != '' && domain != '') {
						var email = user + '@' + domain,
							mailto = email;
						if (subject != '' && subject != undefined && subject != null) {
							email = email + '&subject=' + subject;
							if (bccUser != '' && bccUser != undefined && bccUser != null) {
								var bcc = bccUser + '@' + bccDomain;
								mailto = email + '&bcc=' + bcc;
							}
						} else {
							if (bccUser != '' && bccUser != undefined && bccUser != null) {
								var bcc = bccUser + '@' + bccDomain;
								mailto = email + '?bcc=' + bcc;
							}
						}
						var newMailtoDialogTemplate = mailtoDialogTemplate
													.replaceAll("gmailto", mailto.replace("?", "&"))
													.replaceAll("mailto", mailto)
													.replaceAll("mailoption", "mailto:" + mailto)
													.replaceAll("copyemail", email)
													.replaceAll("copybcc", bcc);
						if(!bcc) {
							newMailtoDialogTemplate = newMailtoDialogTemplate.replace("hidebccblock", "hide");
						}

						var $mailtoTemplate = $("#emailDialogTemplate");
						if ($mailtoTemplate)
							$mailtoTemplate.remove();
						GT.Overlays.runOverlay(newMailtoDialogTemplate, '#emailDialogTemplate', 640, 457, true, true, false, function(){
							$m.focus();
						});

						var clientSelect = document.querySelector('.js-client-select'),
							clientOpen = document.querySelector('.js-client-open');

						document.querySelector('.js-copy').addEventListener('click', function () {
								var copyText = document.getElementById("emailMailtoInput");

								/* Select the text field */
								copyText.select();
								copyText.setSelectionRange(0, 99999); /*For mobile devices*/

								/* Copy the text inside the text field */
								document.execCommand("copy");
								$("#emailDialogTemplate").find('.copied-confirmation.bcc').removeClass('show-confirmation');
								$("#emailDialogTemplate").find('.copied-confirmation.email').addClass('show-confirmation');
						});

						document.querySelector('.js-copy-bcc').addEventListener('click', function () {
								var copyText = document.getElementById("emailBCCtoInput");

								/* Select the text field */
								copyText.select();
								copyText.setSelectionRange(0, 99999); /*For mobile devices*/

								/* Copy the text inside the text field */
								document.execCommand("copy");
								$("#emailDialogTemplate").find('.copied-confirmation.email').removeClass('show-confirmation');
								$("#emailDialogTemplate").find('.copied-confirmation.bcc').addClass('show-confirmation');
						});

						clientSelect.addEventListener('change',
							function () {
								var clientSelection = clientSelect.value;
								clientOpen.setAttribute('href', clientSelection);
							});
					}
				}
			});
	}

	$(document).ready(function () {

		var beforePrint = function (e) {
			$('.email-obfuscate').each(function () {
				$(this).html($(this).attr("data-user") + "@" + $(this).attr("data-domain"));
			});
			$('.email-obfuscate').addClass('printing');

			$('.icon-social-email').each(function () {
				var user, domain;
				if ($(this).find('.ir').length > 0) {
					$(this).find(".ir").html('');
					user = $(this).attr("data-user");
					domain = $(this).attr("data-domain");
					$(this).find(".ir").html(user + "@" + domain);
				}
			});
		};
		var afterPrint = function (e) {
			$('.email-obfuscate').removeClass('printing').html('');
			$('.icon-social-email .ir').html('Email address');
			$('[data-obfuscate="true"]').blur();
		};

		if (window.matchMedia) {
			window.matchMedia('print').addListener(function (mql) {
				if (mql.matches) {
					beforePrint();
				} else {
					afterPrint();
				}
			});
		}

		window.onbeforeprint = beforePrint;
		window.onafterprint = afterPrint;
	}());
};

if (typeof isV1GT == "undefined")
	GT.domContentLoadedFncList.push(function(){
		GT.EmailObfuscate();
	});
GT.GTMGlobal = (function(){
    let fncList = {
        clickBlock: clickEvtBlock,
        megaMenuV3: megaMenuV3ClickEvt,
        megaMenu: megaMenuClickEvt,
        megaMenuV1Mobile: megaMenuClickEvtV1Mobile,
        globalSearch: globalSearch
    };

    function clickEvtBlock() {
        document.querySelectorAll("[data-tracking-block]").forEach(elm => {
            elm.querySelectorAll("a, [data-anchor]").forEach(anchorElm => {
                anchorElm.addEventListener("click", (e) => {
                    let link = e.target.href || e.currentTarget.href || (e.target.dataset && e.target.dataset.anchor) || (e.currentTarget.dataset && e.currentTarget.dataset.anchor),
                        allowTracking = false;

                    if(document.querySelector(".home-page-container"))
                        allowTracking = true;

                    if(link && allowTracking)
                        dataLayer.push({ 
                            'event': 'block_view',
                            'blockName': elm.dataset.trackingBlock, 
                            'blockLink': link
                        });
                })
            })
        })
    }

    function megaMenuV3ClickEvt() {
        setTimeout(() => {
            document.querySelectorAll(".nav3 a, .nav3 [data-anchor]").forEach(elm => {
                if (!elm.dataset.initializedTracking) {
                    elm.dataset.initializedTracking = true;
                    elm.addEventListener("click", (e) => {
                        let currentTarget = e.currentTarget || e.target,
                            link = currentTarget.href || currentTarget.dataset.anchor,
                            containerClick = "level 1",
                            menuLevel_1 = "",
                            menuLevel_2 = "",
                            menuLevel_3 = "";

                        if (currentTarget.closest(".level-1")) {
                            menuLevel_1 = currentTarget.closest(".nav-link")?.innerText;
                        }

                        if (currentTarget.closest(".bleed")) {
                            if (currentTarget.closest(".mega__level--2")) {
                                containerClick = "level 2";
                                menuLevel_2 = currentTarget.closest(".mega__level--2").querySelector(".mega-link--level-2")?.innerText;
                            }
                            if (!menuLevel_1)
                                menuLevel_1 = currentTarget.closest(".bleed")?.dataset.content;
                        }

                        if (currentTarget.closest(".mega-link--level-3")) {
                            if (currentTarget.closest(".mega-link--level-2-placeholder")) {
                                containerClick = "level 2";
                                menuLevel_2 = currentTarget.dataset.linktext ? currentTarget.dataset.linktext : currentTarget.innerText;
                            } else {
                                containerClick = "level 3";
                                menuLevel_3 = currentTarget.innerText;
                            }
                        }

                        if (currentTarget.closest(".header-logo")) {
                            containerClick = "logo";
                        }

                        if (currentTarget.closest(".message-top-banner__message")) {
                            containerClick = "top banner";
                        }

                        if (currentTarget.closest(".additional-link") || currentTarget.closest(".externalLoginButton") || (currentTarget.closest(".mobile__footer") && !currentTarget.closest(".list__global") && !currentTarget.hreflang)) {
                            containerClick = "header";
                            menuLevel_1 = currentTarget.textContent?.trim();
                        }

                        if (currentTarget.closest(".site-language") || (currentTarget.closest(".lang__elem") && currentTarget.hreflang)) {
                            containerClick = "header";
                            menuLevel_1 = "language";
                        }

                        if (currentTarget.closest(".local-site-link")) {
                            containerClick = "header";
                            menuLevel_1 = "member firm";
                        }

                        if (link) {
                            dataLayer.push({
                                'event': 'menu_click',
                                'containerClick': containerClick,
                                'menuLevel_1': menuLevel_1 || "",
                                'menuLevel_2': menuLevel_2 || "",
                                'menuLevel_3': menuLevel_3 || "",
                                'containerLink': link
                            });
                        }
                    })
                }
            })
        }, 1000)
    }

    function megaMenuClickEvt(){
        setTimeout(() => {
            document.querySelectorAll("header a, header [data-anchor]").forEach(elm => {
                if(!elm.dataset.initializedTracking) {
                    elm.dataset.initializedTracking = true;
                    elm.addEventListener("click", (e) => {
                        let currentTarget = e.currentTarget || e.target,
                            link = currentTarget.href || currentTarget.dataset.anchor,
                            containerClick = "level 1",
                            menuLevel_1 = "",
                            menuLevel_2 = "",
                            menuLevel_3 = "";

                        if(currentTarget.closest(".mobile__wrap") && !currentTarget.closest(".mobile__footer")) return;//NAV V1 Mobile

                        if(currentTarget.closest(".level-1")) {
                            menuLevel_1 = currentTarget.closest(".nav-link")?.innerText;
                        }

                        if(currentTarget.closest(".bleed")) {
                            if(
                                (currentTarget.closest(".bleed__col--left") && !currentTarget.closest(".mega-header") && !currentTarget.matches(".mega-link--has-submenu, .group-name-text"))
                                || 
                                (currentTarget.closest(".mega__level--3") && !currentTarget.closest(".bleed").querySelector(".group-name-text.selected"))
                            ) {
                                containerClick = "level 2";
                                menuLevel_2 = currentTarget.closest(".mega-link--level-2")?.innerText || currentTarget.closest(".bleed").querySelector(".bleed__col--left .selected .mega-link--level-2")?.innerText || currentTarget.closest(".bleed").querySelector(".bleed__col--left .mega-link--level-2.active")?.innerText;
                            }
                            if(!menuLevel_1)
                                menuLevel_1 = currentTarget.closest(".bleed")?.dataset.content;
                        }

                        if(currentTarget.closest(".mega__level--3") && !currentTarget.closest(".mega-header") && !currentTarget.closest("span.h3")) {
                            containerClick = "level 3";
                            menuLevel_3 = currentTarget.innerText;
                        }

                        if(currentTarget.closest(".article-tile")) {
                            containerClick = "Related-Insight";
                            menuLevel_3 = "";
                        }

                        if(currentTarget.closest(".header-logo")) {
                            containerClick = "logo";
                        }

                        if(currentTarget.closest(".message-top-banner__message")) {
                            containerClick = "top banner";
                        }

                        if(currentTarget.closest(".additional-link") || currentTarget.closest(".externalLoginButton") || (currentTarget.closest(".mobile__footer") && !currentTarget.closest(".list__global") && !currentTarget.hreflang)) {
                            containerClick = "header";
                            menuLevel_1 = currentTarget.textContent?.trim();
                        }

                        if(currentTarget.closest(".site-language") || (currentTarget.closest(".lang__elem") && currentTarget.hreflang)) {
                            containerClick = "header";
                            menuLevel_1 = "language";
                        }

                        if(currentTarget.closest(".local-site-link")) {
                            containerClick = "header";
                            menuLevel_1 = "member firm";
                        }

                        if(link) {
                            dataLayer.push({ 
                                'event': 'menu_click',
                                'containerClick': containerClick,
                                'menuLevel_1': menuLevel_1 || "",
                                'menuLevel_2': menuLevel_2 || "",
                                'menuLevel_3': menuLevel_3 || "",
                                'containerLink': link
                            });
                        }
                    })
                }
            })
        }, 1000)
    }

    function megaMenuClickEvtV1Mobile() {
        function triggerTracking() {
            setTimeout(() => {
                document.querySelectorAll(".mobile__wrap a, .mobile__wrap [data-anchor]").forEach(elm => {
                    if(!elm.dataset.initialized) {
                        elm.dataset.initialized = true;
                        elm.addEventListener("click", (e) => {
                            triggerTracking();
                            let currentTarget = e.currentTarget || e.target,
                                link = currentTarget.href || currentTarget.dataset.anchor,
                                containerClick = "level 1",
                                menuLevel_1 = "",
                                menuLevel_2 = "",
                                menuLevel_3 = "";

                            if(!currentTarget.closest(".mobile__wrap") || currentTarget.closest("[aria-haspopup]")) return;//NAV V1 Mobile

                            if(currentTarget.closest(".level-1")) {
                                menuLevel_1 = currentTarget.closest(".nav-link")?.innerText;
                            }

                            if(currentTarget.closest(".mobile__level--2") && !currentTarget.closest(".mobile__level--2").querySelector(".group-name-text.mega-link")) {
                                containerClick = "level 2";
                                menuLevel_2 = currentTarget.innerText;
                                menuLevel_1 = currentTarget.closest(".mobile__wrap")?.querySelector(".mobile__level--1 [aria-expanded=true]")?.innerText;
                            }

                            if(currentTarget.closest(".mobile__level--3")) {
                                containerClick = "level 3";
                                menuLevel_3 = currentTarget.innerText;
                                menuLevel_1 = currentTarget.closest(".mobile__wrap")?.querySelector(".mobile__level--1 [aria-expanded=true]")?.innerText;
                                menuLevel_2 = currentTarget.closest(".mobile__wrap")?.querySelector(".mobile__level--2 [aria-expanded=true]")?.innerText;
                            }
            
                            if(currentTarget.closest(".article-tile")) {
                                containerClick = "Related-Insight";
                                menuLevel_3 = "";
                            }

                            if(link) {
                                dataLayer.push({ 
                                    'event': 'menu_click',
                                    'containerClick': containerClick,
                                    'menuLevel_1': menuLevel_1 || "",
                                    'menuLevel_2': menuLevel_2 || "",
                                    'menuLevel_3': menuLevel_3 || "",
                                    'containerLink': link
                                });
                            }
                        })
                    }
                })
            }, 1000)
        }
        document.querySelector("header:not(.nav2) .menu-toggle")?.addEventListener("click", (e) => {
            triggerTracking();
        })
    }

    function globalSearch(){

        const __TYPE_POPULAR = "Popular searches",
            __TYPE_PREVIOUS = "Previous searches",
            __TYPE_RECENT = "Recently visited",
            __TYPE_SUGGESTION = "Search suggestions",
            __TYPE_YOUR_RESULTS = "Your Results",
            __TYPE_ALL_RESULTS = "See all results",
            __TYPE_SITE_SEARCH = "Site Search";

        function pushData(search_term, search_type, search_link, search_text){
            if(search_link && search_type)
                dataLayer.push({
                    'search_term': search_term,
                    'search_type': search_type,
                    'search_link': search_link,
                    'search_text': search_text,
                    'event': 'search_used'
                });
        }

        document.querySelectorAll("#previous-search__container a, .popular-search__container a, .recently-visited__container a, .suggestions-search__container a").forEach(item => {
            if(!item.dataset.initialized) {
                item.addEventListener("click", e => {
                    let currentElm = e.currentTarget || e.target;
                    let searchType = "",
                        searchText = currentElm.innerText,
                        searchTerm = document.querySelector("#searchField")?.value || "";

                    if(currentElm.closest(".search-contents__container.popular-search__container")) searchType = __TYPE_POPULAR;
                    if(currentElm.closest("#previous-search__container")) searchType = __TYPE_PREVIOUS;
                    if(currentElm.closest(".recently-visited__container")) searchType = __TYPE_RECENT;
                    if(currentElm.closest(".suggestions-search__container")) searchType = __TYPE_SUGGESTION;
                    if(currentElm.closest(".has-search__results")) searchType = __TYPE_YOUR_RESULTS;
                    if(currentElm.closest(".viewall-results")) searchText = __TYPE_ALL_RESULTS;
                    if([__TYPE_POPULAR, __TYPE_PREVIOUS, __TYPE_RECENT].indexOf(searchType) >= 0) searchTerm = "";
                    if(searchType) pushData(searchTerm, searchType, currentElm.href, searchText);
                })
                item.dataset.initialized = true;
            }
        })

        let currentFormx = document.querySelector(".header-search__form");
        if(currentFormx && !currentFormx.dataset.initialized) {
            currentFormx.dataset.initialized = true;
            currentFormx.addEventListener("submit", function(e) {
                let currentElm = e.currentTarget || e.target;
                let searchText = currentElm.querySelector("#searchField")?.value;
                const queryString = new URLSearchParams(new FormData(currentElm)).toString()
                pushData(searchText, __TYPE_SITE_SEARCH, currentElm.action + "?" + queryString, searchText);
            })
        }
    }

    return fncList;
});

GT.domContentLoadedFncList.push(function(){
    GT.GTMGlobal = GT.GTMGlobal();
    Object.keys(GT.GTMGlobal).forEach(function(key){
        GT.GTMGlobal[key]();
    })
})